// extracted by mini-css-extract-plugin
export var circle = "_2a-2";
export var icon = "_2a-a";
export var iconHighlight = "_2a-0";
export var lg = "_2a-8";
export var md = "_2a-7";
export var outline = "_2a-4";
export var sm = "_2a-6";
export var square = "_2a-1";
export var xl = "_2a-9";
export var xs = "_2a-5";
export var xxs = "_2a-3";